import { styled } from "../../config/stiches.config";
import * as SliderPrimitive from "@radix-ui/react-slider";

export const Input = styled("input", {
  appearance: "none",
  outline: "none",
  fontFamily: "$inter",
  fontSize: "$2",
  lineHeight: "$2",
  boxSizing: "border-box",
  borderWidth: "1px",
  border: "$gray300 1px solid",
  margin: 0,
  br: "$2",
  py: "$3",
  px: "$4",
  width: "100%",
  "::placeholder": {
    color: "$gray800",
  },
  ["&:focus"]: {
    outline: "$teal600",
    outlineWidth: "1px",
    outlineStyle: "solid",
  },
  ['&[data-extra-credit="true"]']: {
    outline: "$sunshine500",
    outlineWidth: "1px",
    outlineStyle: "solid",
    backgroundColor: "$sunshine50",
    border: "$sunshine500 1px solid",
  },
  variants: {
    state: {
      invalid: {
        outline: "red",
        outlineWidth: "1px",
        outlineStyle: "solid",
        ["&:focus"]: {
          outline: "red",
          outlineWidth: "1px",
          outlineStyle: "solid",
        },
      },
      valid: {},
    },
    height: {
      xlarge: {
        py: "$3",
        px: "$4",
        minHeight: "60px",
        maxHeight: "60px",
      },
      large: {
        py: "$3",
        px: "$4",
        minHeight: "48px",
        maxHeight: "48px",
      },
      medium: {
        py: "$2",
        px: "$4",
        minHeight: "40px",
        maxHeight: "40px",
      },
      small: {
        py: "$1",
        px: "$4",
        minHeight: "38px",
      },
      xsmall: {
        py: "$1",
        px: "$2",
        minHeight: "32px",
      },
    },
    borderless: {
      true: {
        borderWidth: "0px",
        border: "unset",
        ["&:focus"]: {
          outline: "none",
          outlineWidth: "0",
          outlineStyle: "none",
        },
      },
    },
    showErrorOutline: {
      true: {
        border: "1px solid $red600",
        ["&:focus"]: {
          outline: "$red600",
          outlineWidth: "0px",
          outlineStyle: "solid",
        },
      },
    },
  },
  defaultVariants: {
    state: "valid",
    height: "large",
  },
});

export const InputTextArea = styled("textarea", {
  appearance: "none",
  outline: "none",
  fontFamily: "$inter",
  fontSize: "$2",
  lineHeight: "$2",
  boxSizing: "border-box",
  borderWidth: "1px",
  border: "$gray300 1px solid",
  margin: 0,
  br: "$2",
  minHeight: "48px",
  py: "$3",
  px: "$4",
  width: "100%",
  "::placeholder": {
    color: "$gray800",
  },
  ["&:focus"]: {
    outline: "$teal600",
    outlineWidth: "1px",
    outlineStyle: "solid",
  },
  variants: {
    state: {
      invalid: {
        outline: "red",
        outlineWidth: "1px",
        outlineStyle: "solid",
        ["&:focus"]: {
          outline: "red",
          outlineWidth: "1px",
          outlineStyle: "solid",
        },
      },
      valid: {},
    },
  },
  defaultVariants: {
    state: "valid",
  },
});

export const InputCheckbox = styled("input", {
  height: "16px",
  width: "16px",
  fontSize: "12px",
  ["&:checked"]: {
    display: "block",
    backgroundColor: "$colors$teal600",
    color: "white",
  },
  [`&:after`]: {
    content: "",
    position: "absolute",
    display: "none",
  },
});

export const InputStiches = styled("input", {});

const StyledSlider = styled(SliderPrimitive.Root, {
  position: "relative",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  touchAction: "none",
  width: 200,

  '&[data-orientation="horizontal"]': {
    height: 20,
  },

  '&[data-orientation="vertical"]': {
    flexDirection: "column",
    width: 20,
    height: 100,
  },
});

const StyledTrack = styled(SliderPrimitive.Track, {
  backgroundColor: "$gray300",
  position: "relative",
  flexGrow: 1,
  borderRadius: "9999px",

  '&[data-orientation="horizontal"]': { height: 3 },
  '&[data-orientation="vertical"]': { width: 3 },
});

const StyledRange = styled(SliderPrimitive.Range, {
  position: "absolute",
  backgroundColor: "$colors$teal600",
  borderRadius: "9999px",
  height: "100%",
});

const StyledThumb = styled(SliderPrimitive.Thumb, {
  all: "unset",
  display: "block",
  width: 16,
  height: 16,
  backgroundColor: "$colors$teal600",
  boxShadow: `0 2px 10px $gray300`,
  borderRadius: 8,
  "&:hover": { backgroundColor: "$colors$teal700" },
  "&:focus": { boxShadow: `0 0 0 5px $gray300` },
});

export const Slider = {
  StyledSlider,
  StyledTrack,
  StyledRange,
  StyledThumb,
};
